import React, { type FC } from 'react';
import styled from 'styled-components';
import { Tag, TagGroup } from '@oneaudi/unified-web-components';

export interface FilterTagProps {
  readonly id: string;
  readonly onClickHandler: () => void;
  readonly text: string;
  readonly selected?: boolean;
  readonly disabled?: boolean;
  // todo: there is no export for IconNamesMerged, so by now a workaround is used here
  readonly icon?: 'more';
  readonly dataTestId?: string;
  readonly size?: 'sm' | 'md';
  readonly className?: string;
}

export const FilterTag: FC<FilterTagProps> = ({
  id,
  onClickHandler,
  text,
  selected = false,
  disabled = false,
  icon,
  dataTestId,
  size = 'md',
  className,
}) => (
  <StyledTag
    id={id}
    data-testid={dataTestId}
    margin={[0, 0, 0, 0]}
    name={`select ${id}`}
    onChange={() => {}}
    onClick={!disabled ? onClickHandler : undefined}
    size={size}
    variant="selectable"
    label={<span translate="yes">{text}</span>}
    value={id}
    checked={selected}
    disabled={disabled}
    icon={icon}
    className={className}
  />
);

interface StyledTagProps {
  icon?: React.ReactNode;
  checked?: boolean;
}
// hide selected tick until alpha design has option to do so
const StyledTag = styled(Tag)<StyledTagProps>`
  svg {
    display: ${({ checked, icon }) => (checked || !icon ? 'none' : 'inline')};
  }
  div {
    background-color: ${({ checked, theme }) =>
      checked ? theme.colors.tagSelectedBgColor : 'none'};
  }
`;

export const Wrapper = styled(TagGroup)`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: stretch;
  row-gap: var(--spacing-relative-xs);
  column-gap: var(--spacing-relative-2xs);
  border: 0;
  padding: 0;
`;
